<!--底部-->
<template>
  <div class="foot">
    <div class="container-xl link">
      <div class="select">
        <span class="label">子公司：</span>
        <Select v-model="model" style="width:400px" size="large" @on-select="changeSelect">
          <Option :value="index" v-for="(item,index) of dataList" :key="index">{{item.name}}</Option>
        </Select>

      </div>
      <div class="text">
        <div class="a">关注新盛
          <div class="wxImg"><img src="../assets/img/gzh.jpg" alt=""></div>
        </div>
        <div class="b">|</div>
        <div class="a" @click="toPage(tree)">联系我们</div>
        <div class="b">|</div>
        <div class="a" @click="opeemail">新盛信箱</div>
        <!-- <div class="b">|</div> -->
        <!-- <div class="a"><a target="_blank" href="http://oa.xstzgs.com:88/">OA办公系统</a></div> -->
      </div>
    </div>
    <div class="pc">
      <span>COPYRIGHT@XUZHOU XINSHENG INVESTMENT HOLDING GROUP CO.,LTD ALL RIGHTS RESERVED</span>
      <a href="https://beian.miit.gov.cn/" target="_blank">备案号： 苏ICP备19002970号 </a>
      <span> 版权所有</span>
    </div>
    <!-- <div class="iphone">
        新盛集团版权所有
    </div> -->
  </div>
</template>

<script>
import { GetContentForClass } from "@/api";
export default {
  data() {
    return {
      model: localStorage.getItem("model")
        ? Number(localStorage.getItem("model"))
        : 1,
      dataList: [],
    };
  },
  mounted() {
    GetContentForClass({ scode: 37 }).then((res) => {
      this.dataList = res;
    });
  },
  computed: {
    //所有菜单
    tree() {
      return this.$store.state.user.tree;
    },
    //一级菜单
    one() {
      return this.$store.state.user.one;
    },
  },
  // ?mcode=0&one=6&tow=0&three=-1&scode=39
  // ?one=6&tow=0&three=0&mcode=0&scode=39
  methods: {
    changeSelect(e) {
      this.model = e.value;
      localStorage.setItem("model", e.value);
      let item = this.dataList[e.value];
      // debugger
      let param = {};
      param.one = item.classIds[0];
      param.tow = item.classIds[1];
      param.three = -1;
      param.mcode = item.mcode;
      param.scode = item.scode;
      param.id = item.id;

      if (item.classIds.length == 3) {
        param.three = item.classIds[2];
      }

      let routeUrl = this.$router.resolve({
        path: "/page",
        query: param,
      });
      window.open(routeUrl.href, "_blank");
    },

    opeemail() {
      window.open("http://www.xstzgs.com/LetterInfo/LetterInfo/XinShengMail.html");
    },
    //跳转详情
    toPage(tree) {
      // ?mcode=0&one=4&tow=1&three=-1&scode=23
      let param = {};
      tree.forEach((item, index) => {
        if (item.subs) {
          for (let i = 0; i < item.subs.length; i++) {
            if (item.subs[i].name == "联系我们") {
              param.mcode = 0;
              param.one = index;
              param.tow = i;
              param.three = -1;
              param.scode = item.subs[i].scode;
              break;
            }
          }
        }
      });

      let routeUrl = this.$router.resolve({
        path: "/page",
        query: param,
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style scoped lang="less">
.foot {
  margin-top: 20px;
  .link {
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    .select {
      flex: 1;
      .label {
        font-size: 14px;
        padding-right: 1px;
        color: #666;
      }
    }
    .text {
      display: flex;
      align-items: center;
      font-size: 14px;
      div {
        padding: 10px;
      }
      .a {
        transition: all 0.2;
        cursor: pointer;
        position: relative;
        &:hover {
          color: #b50003;
          .wxImg {
            display: block;
          }
        }
        .wxImg {
          display: none;
          position: absolute;
          bottom: 35px;
          left: 0;
          padding: 0;
        }
      }
      a {
        transition: all 0.2;
        cursor: pointer;
        position: relative;
        color: #515a6e;
        &:hover {
          color: #b50003;
          .wxImg {
            display: block;
          }
        }
        .wxImg {
          display: none;
          position: absolute;
          bottom: 35px;
          left: 0;
          padding: 0;
        }
      }
      .b {
        color: #ddd;
        font-size: 12px;
      }
    }
  }
  .pc {
    padding: 16px 10px;
    background-color: #b50003;
    text-align: center;
    font-size: 13px;
    color: #fff;

    a {
      color: #fff;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .iphone {
    display: none;
  }
}

@media (max-width: 992px) {
  .foot {
    .link {
      display: none;
    }
    .pc {
      font-size: 12px;
      font-family: Arial, Helvetica, sans-serif;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue